import React from 'react';

import { useField } from 'formik';

import Tooltip from 'CommonComponents/Tooltip';

import InformationCircleIcon from 'Assets/icons/information-circle.svg';

export default function SelectFromField({
    label,
    horizontalLayout,
    parentGridClass = 'tw-grid-cols-3',
    labelGridClass = 'tw-col-span-1',
    inputGridClass = 'tw-col-span-2',
    ...props
}) {
    const showInfo = props.showInfo;
    const tooltipInfo = props.tooltipinfo;
    delete props['showInfo'];
    const [field, meta, helpers] = useField(props);
    return horizontalLayout ? (
        <div className={parentGridClass + ' tw-grid tw-gap-4'}>
            {label && (
                <div className={labelGridClass}>
                    <label htmlFor={props.name} className="tw-flex tw-gap-x-1 tw-text-charcoal tw-text-sm tw-mb-0">
                        {label} {props.required && '*'}
                        {tooltipInfo && !showInfo && (
                            <Tooltip placement="right-end" tooltipContent={$t(tooltipInfo)} tooltipType="text">
                                <div className="tw-flex tw-items-center tw-justify-center tw-cursor-pointer">
                                    <InformationCircleIcon className="tw-mt-0 tw-mb-0 tw-p-0" />
                                </div>
                            </Tooltip>
                        )}
                    </label>
                </div>
            )}
            <div className={inputGridClass}>
                <div className={'tw-flex tw-flex-row tw-items-center tw-gap-x-1'}>
                    <select
                        className={
                            meta.touched && meta.error ? 'tw-border tw-border-red-500 select-input tw-space-y-1.5' : 'tw-border-0 select-input tw-space-y-1.5'
                        }
                        {...field}
                        {...props}
                    >
                        {props.children}
                    </select>
                    {showInfo && <InformationCircleIcon className="tw-mt-0 tw-mb-0 tw-p-0 tw-cursor-pointer" onClick={() => showInfo()} />}
                </div>
                {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
            </div>
        </div>
    ) : (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            {label && (
                <label htmlFor={props.name} className="tw-text-charcoal tw-text-sm tw-mb-0">
                    {$t(label)} {props.required && '*'}
                </label>
            )}
            <div className={' tw-flex tw-flex-row tw-items-center tw-gap-x-1'}>
                <select className={meta.touched && meta.error ? 'tw-border tw-border-red-500 select-input' : 'tw-border-0 select-input'} {...field} {...props}>
                    {props.children}
                </select>
                {showInfo && <InformationCircleIcon className="tw-mt-0 tw-mb-0 tw-p-0 tw-cursor-pointer" onClick={() => showInfo()} />}
            </div>
            {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
        </div>
    );
}
